import React, { useEffect } from 'react';
import { Element, useNode } from '@craftjs/core';
import { useContextSelector } from 'use-context-selector';
import { CalculatedBlock } from '../Containers/CalculatedBlock';
import { generateBMIDataKeys, FormFillContext } from '../../uiEditor/provider/formFill.context';
import { textInputDefaultPropsFactory } from '../../../../features/forms/base/controls/inputs/TextInput';
import { useScopedTranslation } from '../../../../application/localisation/useScopedTranslation';
import { NumberInput } from '../Inputs/NumberInput';
import { bmiInputV2DefaultPropsFactory, IBmiInputV2 } from 'src/features/forms/base/controls/specials/BmiInputV2';
import { calculatedInputPropsFactory } from 'src/features/forms/base/controls/specials/CalculatedBlock';
import { Container, ContainerSettings } from '../Containers/Container';

export const BmiInputV2: IBmiInputV2 = (props) => {
  const { t } = useScopedTranslation('Forms.Controls.BMI');
  const {
    connectors: { connect, drag },
  } = useNode();

  const dataKeys = generateBMIDataKeys(props.dataKey);

  const isOnlyView = useContextSelector(FormFillContext, (v) => v.mode === 'Overview');
  const weightValue = useContextSelector(FormFillContext, (v) => (v.values ? v.values[dataKeys.weight] : undefined));
  const heightValue = useContextSelector(FormFillContext, (v) => (v.values ? v.values[dataKeys.height] : undefined));
  const setDataBlockFieldValue = useContextSelector(FormFillContext, (v) => v.setValue);

  useEffect(() => {
    if (isOnlyView) return;

    const weight = Number(weightValue);
    const height = Number(heightValue);
    let bmi;
    if (weight && height) {
      const calc = weight / Math.pow(height / 100, 2);
      bmi = calc < 10 ? undefined : calc.toFixed(1);
      bmi = calc > 999 ? undefined : calc.toFixed(1);
    }

    setDataBlockFieldValue?.(dataKeys.bmi, bmi, { dontTouchField: true });
  }, [weightValue, heightValue, setDataBlockFieldValue, isOnlyView, dataKeys.bmi]);

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))}>
      <Container {...props}>
        <Element
          is={NumberInput}
          id={'Weight'}
          {...textInputDefaultPropsFactory()}
          hasSkipCheckBox={props.hasSkipCheckBox}
          dataKey={dataKeys.weight}
          size={'100%'}
          label={t('Weight')}
          units={'kg'}
        />
        <Element
          is={NumberInput}
          id={'Height'}
          {...textInputDefaultPropsFactory()}
          hasSkipCheckBox={props.hasSkipCheckBox}
          dataKey={dataKeys.height}
          size={'100%'}
          label={t('Height')}
          units={'cm'}
        />
        <Element
          is={CalculatedBlock}
          id={'BMI'}
          {...calculatedInputPropsFactory()}
          dataKey={dataKeys.bmi}
          size={'50%'}
          label={'BMI'}
        />
      </Container>
    </div>
  );
};

const BmiSettings = () => {
  return <ContainerSettings />;
};

BmiInputV2.craft = {
  defaultProps: bmiInputV2DefaultPropsFactory(),
  related: {
    settings: BmiSettings,
  },
};
